import React from "react";

export default function TerminatePageViaSurvey() {
    return (
        <div
            style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                padding: "10px",
                transform: "translate(-50%, -50%)",
                fontSize: "30px",
                fontWeight: "700",
            }}
        >
            <center>Votre rendez-vous Visio Orange est terminé</center>
            {/* <div style={{ marginTop: "20px" }} className="text-center">
                <button
                    className="btn btn-dark login-btn"
                    onClick={() => window.close(window.location.href)}
                    style={{ minWidth: "200px" }}
                >
                    Fermer la fenêtre{" "}
                </button>
            </div> */}
        </div>
    );
}
